// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2D37J","notes":"Notes_notes__9-ezD","note":"Notes_note__20GsW","markdown":"Notes_markdown__3p2fq"};